/**
 * @param {string} resourceId
 */
export function isPresentationId(resourceId) {
    return typeof resourceId === "string" && /[0-9A-F]{32,32}1d/i.test(resourceId);
}
